// extracted by mini-css-extract-plugin
export var attachment = "_ks-a";
export var emailContainer = "_ks-4";
export var emailContentPaddedContainer = "_ks-b";
export var emailHeader = "_ks-6";
export var emailIframe = "_ks-3";
export var emailInfoIcon = "_ks-9";
export var emailShortenedSummary = "_ks-e";
export var infoDropdown = "_ks-0";
export var infoRowBoundedContent = "_ks-d";
export var internal = "_ks-5";
export var merchant = "_ks-8";
export var messageInputContainer = "_ks-h";
export var normal = "_ks-7";
export var replyCard = "_ks-f";
export var subtleButton = "_ks-1";
export var subtleButtonIconContainer = "_ks-2";
export var toggleViewRepliesButton = "_ks-c";
export var wrappingText = "_ks-g";